import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchOrganizations = createAsyncThunk(
  "organization/fetchOrganizations",
  async () => {
    const jwtToken = localStorage.getItem("jwt_token");
    const url = `${process.env.REACT_APP_API_URL}/organisations`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    });

    const orgs = response.data.data.organizations.map((one) => ({
      ...one,
      value: one.id,
      label: one.name,
    }));

    return orgs;
  }
);

const initialState = {
  organizations: [],
  selectedOrganization: null,
  loading: false,
  error: null,
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setSelectedOrganization: (state, action) => {
      state.selectedOrganization = action.payload;
    },

    clearSelectedOrganization: (state) => {
      state.selectedOrganization = null;
    },

    resetOrganizationState: () => initialState,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganizations.fulfilled, (state, action) => {
        state.loading = false;
        state.organizations = action.payload;
      })
      .addCase(fetchOrganizations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  setSelectedOrganization,
  clearSelectedOrganization,
  resetOrganizationState,
} = organizationSlice.actions;

export default organizationSlice.reducer;